<template>
    <div>
        <fluke-card>
            <header>
                <div class="title">Adicionar Categoria</div>
                <div class="description">Adicione as informações da categoria</div>
            </header>
            <main>
                <v-text-field label="Título" v-model="category"></v-text-field>
            </main>
            <footer>
                <fluke-button v-on:click.native="submit">Adicionar</fluke-button>
            </footer>
        </fluke-card>
    </div>
</template>

<script>
import axios from 'axios';

import Card from '../../../components/Main/Content/Card/Card.vue';
import Button from '../../../components/Main/Content/Button/Button.vue';

import permission from '../../../mixins/permissions';

export default {
    mixins: [ permission ],
    components: {
        'fluke-card': Card,
        'fluke-button': Button
    },
    data: function() {
        return {
            category: '',
            permission: {
                read: false,
                write: false
            }
        }
    },
    created: function() {
        this.permission = this.getUserPagePermission('blog');
        if( this.permission.read == false || this.permission.write == false ) {
			this.$router.push('/');
		}
    },
    methods: {
        submit: async function() {
            const result = await axios.post(
				this.$myServerAddresses.blog + 'categories',
				{
                    category: this.category
				},
                {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );
            this.$router.push({ name: 'blog-categories' });
        }
    }
}
</script>
